<template>
   <div style="width: 100%;height: 100%;background-color: #fff;">
    <div v-if="Number(userInfo.apply_exam_status.status) === 1" style="width: 100%;height: 100%;">
        <!-- 人员信息部分 -->
        <el-card class="box-card" header="考生信息">
        <template>
            <el-row>
                <el-form label-width="120px">
                    <el-col :span="12">
                        <el-form-item label="姓名：" required>
                            <el-input v-model="username"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        <el-form-item label="身份证号码：" required>
                            <el-input v-model="id_number"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        <el-form-item label="手机号：" >
                            <span >{{userInfo.mobile}}</span>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        <el-form-item label="电子邮箱：" required>
                            <el-input v-model="mail"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </template>
        </el-card>

        <!-- 考试信息部分 -->
        <el-card class="box-card" header="考试信息">
        <template >
            <el-row>
                <el-form label-width="120px">
                    <el-col :span="24">
                        <el-form-item label="考试名称：">
                            <span >{{examInfo.name}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考试开始时间：">
                            <span >{{examInfo.start_time}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考试结束时间：">
                            <span >{{examInfo.end_time}}</span>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </template>
        </el-card>
        <div class="apply-exam" @click="apply">立即申请</div>
    </div>

    <div v-else class="profile-mod-status">{{ userInfo.apply_exam_status.status_text }}</div>
     
   </div>
</template>
<script>
import { Message } from 'element-ui';
import {mapState} from 'vuex'
export default {
   name: '',
   components: {
   },
   computed:mapState([
        'userInfo',
    ]),
   mixins: [],
   props: {
     
   },
   data() {
     return {
        personList: [],
        examInfo: {},
        username: '',
        id_number: '',
        mail: ''
     }
   },
   watch: {
     
   },
   mounted() {
    const {username,id_number, mail} = this.userInfo;
    this.username = username;
    this.id_number = id_number;
    this.mail = mail;
    this.getExamInfo();
   },
   methods: {
     getExamInfo(){
        this.$http.get('/api/exam/getExamAffairList?is_apply_exam=1').then(res => {
            console.log(res,'res')
            if(res&&res.length>0){
                this.examInfo = res[0]
            }
        })
     },
     apply(){
        if(!this.username){
            Message.warning('请输入姓名');
            return false
        }
        if(!this.id_number){
            Message.warning('请输入身份证号码');
            return false
        }
        if(!this.mail){
            Message.warning('请输入电子邮箱');
            return false
        }
        this.$http.post('/api/Exam/proposerExamRecord',{
            examAffairId: this.examInfo.id,
            username: this.username,
            mail: this.mail,
            id_number: this.id_number
        }).then(() => {
            this.$message.success('申请已提交')
            this.userInfo.apply_exam_status.status = 0
            this.userInfo.apply_exam_status.status_text = '已申请'
        })
     },
   }
};
</script>
<style lang='scss' scoped>
.apply-exam{
    width: 100px;
    line-height: 35px;
    height: 35px;
    color: #fff;
    text-align: center;
    background: #285492;
    margin: 15px auto;
    cursor: pointer;
}
</style>